import { Corner } from 'components/site/general/singleSelect/SelectedMarkerV2/Corner';
import { useEffect, useRef, useState } from 'react';
import { IXY } from 'react-give-me-map/dist/utils/map/mapTypes';
import styled from 'styled-components/macro';

interface Props {
    color: string;
    rotation?: number;
    onDrag: (offsetX: number, offsetY: number, index: number) => void;
    onDragEnd: (offsetX: number, offsetY: number, index: number) => void;
}
export const ResizePoints = (props: Props) => {
    const [currentDragIndex, setCurrentDragIndex] = useState(null);
    const startMovementCoordinatesRef = useRef<IXY>(null);

    const containerRef = useRef<HTMLDivElement>();

    useEffect(() => {
        function mouseMove(event: MouseEvent) {
            if (currentDragIndex === null) {
                return;
            }

            const movement = {
                x: event.clientX - startMovementCoordinatesRef.current.x,
                y: event.clientY - startMovementCoordinatesRef.current.y
            };
            props.onDrag(movement.x, movement.y, currentDragIndex);
            event.preventDefault();
        }

        function mouseUp(event) {
            if (currentDragIndex !== null) {
                const movement = {
                    x: event.clientX - startMovementCoordinatesRef.current.x,
                    y: event.clientY - startMovementCoordinatesRef.current.y
                };
                props.onDragEnd(movement.x, movement.y, currentDragIndex);
                setCurrentDragIndex(null);
            }
        }

        document.addEventListener('mousemove', mouseMove);
        document.addEventListener('mouseup', mouseUp);

        return () => {
            document.removeEventListener('mousemove', mouseMove);
            document.removeEventListener('mouseup', mouseUp);
        };
    }, [currentDragIndex]);

    function getCursor(index: number) {
        if (index === 0 || index === 2) {
            return 'nwse-resize';
        } else {
            return 'nesw-resize';
        }
    }

    return (
        <S_DragPoints ref={containerRef}>
            {[0, 1, 2, 3].map((id, i) => {
                const getPosition = () => {
                    if (i === 0) {
                        return { left: 0, top: 0 };
                    }
                    if (i === 1) {
                        return { right: 0, top: 0 };
                    }
                    if (i === 2) {
                        return { right: 0, bottom: 0 };
                    }
                    if (i === 3) {
                        return { left: 0, bottom: 0 };
                    }
                };
                return (
                    <div key={id} style={{ ...getPosition(), position: 'absolute' }}>
                        <Corner
                            className={'handle'}
                            style={{
                                pointerEvents: 'all',
                                position: 'relative'
                            }}
                            cursor={getCursor(i)}
                            onMouseDown={(e) => {
                                setCurrentDragIndex(i);
                                startMovementCoordinatesRef.current = {
                                    x: e.clientX,
                                    y: e.clientY
                                };
                            }}
                        />
                    </div>
                );
            })}
        </S_DragPoints>
    );
};

const S_DragPoints = styled.div`
    left: 0px;
    right: 0px;
    bottom: 0px;
    top: 0px;
    position: absolute;
`;
